// extracted by mini-css-extract-plugin
module.exports = {"overlay-modal":"modal_overlay-modal__1_3y_","modal":"modal_modal__3wusI","close":"modal_close__1RQy3","fadeIn":"modal_fadeIn__3XReG","fadeIn2":"modal_fadeIn2__2WMVf"};